import React from "react";

/* "More tools built for gig workers" — roadmap row that lives just below
 * the How It Works section. Visually secondary so it doesn't compete with
 * the core Float story.
 */
const ROADMAP = [
  { id: "dashboard", title: "Earnings Dashboard", body: "View earnings across multiple platforms in one place." },
  { id: "mileage",   title: "Mileage Tracking",   body: "Automatically track business miles and simplify tax season." },
  { id: "savings",   title: "Savings Tools",      body: "Build emergency funds and prepare for taxes." },
  { id: "insights",  title: "Income Insights",    body: "Discover your most profitable times, zones, and platforms." },
];

const RoadmapCard = ({ r }) => (
  <div
    data-testid={`roadmap-card-${r.id}`}
    className="relative rounded-2xl p-5 bg-[#0A0A0A] border border-white/[0.06] hover:border-[#00FF88]/25 transition-colors duration-300"
  >
    <div className="font-mono-c text-[9px] uppercase tracking-[0.28em] text-white/35 mb-3">
      // Coming soon
    </div>
    <h4 className="font-display font-bold text-base text-white tracking-tight mb-1.5">
      {r.title}
    </h4>
    <p className="text-white/50 text-[13px] leading-relaxed">{r.body}</p>
  </div>
);

const FeaturesBento = () => (
  <section
    id="roadmap"
    data-testid="roadmap-section"
    className="relative py-24 md:py-28 border-t border-white/5"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="max-w-3xl mb-10 md:mb-12">
        <div className="font-mono-c text-[10px] uppercase tracking-[0.3em] text-white/45 mb-3">
          // Coming soon
        </div>
        <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold leading-tight tracking-tight text-white/85">
          More tools built for gig workers.
        </h3>
        <p className="mt-3 text-white/50 text-sm lg:text-base max-w-xl leading-relaxed">
          GigAfloat is building a complete financial platform for the gig economy.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {ROADMAP.map((r) => <RoadmapCard key={r.id} r={r} />)}
      </div>
    </div>
  </section>
);

export default FeaturesBento;
